module.exports = __webpack_public_path__ + "img/resto.601dc8dc.png";